<div class="container">
  <div class="px-6 py-4 border-b flex items-center header-title">
    <h2 class="title m-0">{{"CHALLENGE-TIME.CREATE-TIME-CHALL" | translate}}</h2>
  </div>
  <div class="card p-3">
    <div class="form-row">
      <mat-form-field appearance="fill">
        <mat-label>{{"CHALLENGE-TIME.TITLE" | translate}} it</mat-label>
        <input matInput [(ngModel)]="item.i18nTitle['IT']" required>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>{{"CHALLENGE-TIME.TITLE" | translate}} en</mat-label>
        <input matInput [(ngModel)]="item.i18nTitle['EN']" required>
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field appearance="fill">
        <mat-label>{{"CHALLENGE-TIME.PUBLISH" | translate}}</mat-label>
        <input matInput [matDatepicker]="pickerPubblicazione" [(ngModel)]="item.startDate" required>
        <mat-datepicker-toggle matSuffix [for]="pickerPubblicazione"></mat-datepicker-toggle>
        <mat-datepicker #pickerPubblicazione></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>{{"CHALLENGE-TIME.EXPIRE" | translate}}</mat-label>
        <input matInput [matDatepicker]="pickerScadenza" [(ngModel)]="item.endDate" required>
        <mat-datepicker-toggle matSuffix [for]="pickerScadenza"></mat-datepicker-toggle>
        <mat-datepicker #pickerScadenza></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field appearance="fill">
        <mat-label>{{"CHALLENGE-TIME.ACCEPTANCE" | translate}}</mat-label>
        <input matInput type="number" [(ngModel)]="item.acceptancePeriod" required>
      </mat-form-field>
      <div class="d-flex-draft">
        <mat-label>{{"CHALLENGE-TIME.DRAFT" | translate}}</mat-label>
        <mat-slide-toggle [(ngModel)]="item.draft">
        </mat-slide-toggle>
      </div>
    </div>
    <div class="form-row">
      <mat-form-field appearance="fill">
        <mat-label>Img {{"GLOBAL.ITA" | translate}}</mat-label>
        <input matInput [(ngModel)]="item.i18nThumb['IT']" required>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Img {{"GLOBAL.ENG" | translate}}</mat-label>
        <input matInput [(ngModel)]="item.i18nThumb['EN']" required>
      </mat-form-field>
    </div>
    <div class="form-row" *ngIf="item.i18nThumbDetail">
      <mat-form-field appearance="fill">
        <mat-label>Img URL {{"CHALLENGE-TIME.DETAIL" | translate}} {{"GLOBAL.ITA" | translate}}</mat-label>
        <input matInput [(ngModel)]="item.i18nThumbDetail['IT']" required>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Img URL {{"CHALLENGE-TIME.DETAIL" | translate}} {{"GLOBAL.ENG" | translate}}</mat-label>
        <input matInput [(ngModel)]="item.i18nThumbDetail['EN']" required>
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field appearance="fill">
        <mat-label>{{"CHALLENGE-TIME.DESC" | translate}} {{"GLOBAL.ITA" | translate}}</mat-label>
        <textarea cols="30" rows="4" matInput [(ngModel)]="item.i18nDescription['IT']" required></textarea>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>{{"CHALLENGE-TIME.DESC" | translate}} {{"GLOBAL.ENG" | translate}}</mat-label>
        <textarea cols="30" rows="4" matInput [(ngModel)]="item.i18nDescription['EN']" required></textarea>
      </mat-form-field>
    </div>

    <div class="bottoni">
      <button (click)="confirmClose()" mat-button-base class="m-4">{{"GLOBAL.CLOSE" | translate}}</button>
      <button mat-raised-button (click)="submit()" [disabled]="isFormInvalid()" class="m-4 bottone-viola">
        {{"GLOBAL.CREATE" | translate}}
      </button>
    </div>
  </div>
</div>
